(function() {

    if (!document.querySelector('.c24-loading-tile')
        && !document.querySelector('.div24TeaserTilesDynamic .loading')) {
        return;
    }

    window._paq.push([
        function() {
            if (window.c24VssInfoSent) {
                return;
            }

            window.c24VssInfoSent = true;

            $.ajax({
                type: 'GET',
                url: window.c24LpRoot + 'api/?k=24&a=vssinfo',
                dataType: 'json',
                timeout: 10 * 1000,
                async: true,
            });
        },
    ]);
})();
